import { Lazyload } from "../../base/cutil/Lazyload";
import { StoreBase } from "../../base/cutil/StoreBase";
import { PayWallUtil } from "../util/PayWallUtil";
import isBlank from "@sedan-utils/is-blank";
export class SubscriptionStore extends StoreBase {
    constructor(brainClient, preferencesStore, webConfigStore) {
        super(() => []);
        this.brainClient = brainClient;
        this.preferencesStore = preferencesStore;
        this.webConfigStore = webConfigStore;
        this.stripePlansLazyLoad = new Lazyload(() => {
            return this.brainClient.payWall.plans().then(res => {
                const state = res;
                this.emit(state);
                return state;
            });
        });
        this.currentPlanLazyLoad = new Lazyload(async () => {
            const webFeature = await this.webConfigStore.imagicaCreatorPlans();
            return await PayWallUtil.currentPlan(this.preferencesStore, this.brainClient, webFeature).then(res => {
                const state = res;
                this.emit(state);
                return state;
            });
        });
        this.imagicaCreatorPlansLazyLoad = new Lazyload(async () => {
            const currentPlan = await this.currentPlan();
            const stripePlans = await this.stripePlansLazyLoad.get().then(res => res.data);
            const metadatas = await this.webConfigStore.imagicaCreatorPlans();
            const downgradePopup = await this.webConfigStore.imagicaCreatorDowngradePlanPopup();
            const showDowgradePopup = !isBlank(downgradePopup[currentPlan.value]?.items);
            let imagicaPlans = [];
            const freePlan = metadatas.find(metadata => metadata.free);
            if (freePlan) {
                freePlan.current_plan = currentPlan.value === freePlan.value;
                freePlan.current_plan_is_canceled = currentPlan.isCancel;
                freePlan.downgrade_button = freePlan.downgrade_button || {};
                //处理plan表格是否显示popup
                // if (showDowgradePopup && !isBlank(freePlan.downgrade_button) && !isBlank(currentPlan.customer)) {
                // freePlan.downgrade_button = { ...freePlan.downgrade_button, popup: downgradePopup[currentPlan.value] };
                // }
                imagicaPlans.push(freePlan);
            }
            for (const plan of stripePlans) {
                const target = metadatas.find(metadata => metadata.value === plan.metadata.value) ??
                    metadatas.find(metadata => metadata.value === "pro");
                if (target && plan.active === true) {
                    const targetPrices = await this.brainClient.payWall.planPrice(plan.id).then(res => res.data);
                    const monthPrice = targetPrices.find(price => price.recurring.interval === "month");
                    const annualPrice = targetPrices.find(price => price.recurring.interval === "year");
                    target.price_month.priceId = monthPrice?.id;
                    target.price_month.amount = monthPrice?.unit_amount_decimal;
                    target.price_month.interval = monthPrice?.recurring.interval;
                    target.price_month.interval_count = monthPrice?.recurring.interval_count;
                    target.price_annual.priceId = annualPrice?.id;
                    target.price_annual.amount = annualPrice?.unit_amount_decimal;
                    target.price_annual.interval = annualPrice?.recurring.interval;
                    target.price_annual.interval_count = annualPrice?.recurring.interval_count;
                    target.current_plan = currentPlan.value === target.value;
                    target.current_plan_is_canceled = currentPlan.isCancel;
                    if (target.current_plan && currentPlan.isCancel && !isBlank(currentPlan.expiryDate)) {
                        target.expiryDate = currentPlan.expiryDate;
                    }
                    target.downgrade_button = target.downgrade_button || {};
                    //处理plan表格是否显示popup
                    // if (showDowgradePopup && !isBlank(target.downgrade_button) && !isBlank(currentPlan.customer)) {
                    //  target.downgrade_button = { ...target.downgrade_button, popup: downgradePopup[currentPlan.value] };
                    // }
                    imagicaPlans.push(target);
                }
            }
            //按每月金额升序
            imagicaPlans.sort((a, b) => {
                let aAmountPreMonth = 0;
                let bAmountPreMonth = 0;
                if (!isBlank(a.price_month.amount) &&
                    !isBlank(a.price_month.interval_count) &&
                    !isNaN(Number(a.price_month.amount)) &&
                    !isNaN(Number(a.price_month.interval_count))) {
                    aAmountPreMonth = Number(a.price_month.amount) / Number(a.price_month.interval_count);
                }
                if (!isBlank(b.price_month.amount) &&
                    !isBlank(b.price_month.interval_count) &&
                    !isNaN(Number(b.price_month.amount)) &&
                    !isNaN(Number(b.price_month.interval_count))) {
                    bAmountPreMonth = Number(b.price_month.amount) / Number(b.price_month.interval_count);
                }
                return aAmountPreMonth - bAmountPreMonth;
            });
            //添加is_show_downgrage_button
            const currentPlanIndex = imagicaPlans.findIndex(x => x.value === currentPlan.value);
            imagicaPlans = imagicaPlans.map((x, index) => {
                return {
                    ...x,
                    is_show_downgrage_button: index < currentPlanIndex,
                };
            });
            return imagicaPlans;
        });
    }
    async renew() {
        this.imagicaCreatorPlansLazyLoad.renew();
        this.stripePlansLazyLoad.renew();
        this.currentPlanLazyLoad.renew();
    }
    async dirty() {
        this.currentPlanLazyLoad.dirty();
        this.stripePlansLazyLoad.dirty();
        this.imagicaCreatorPlansLazyLoad.dirty();
    }
    async currentPlan() {
        return this.currentPlanLazyLoad.get();
    }
    async imagicaCreatorPlans() {
        return this.imagicaCreatorPlansLazyLoad.get();
    }
    async imagicaFeatures() {
        return this.webConfigStore.imagicaFeatures();
    }
    async imagicaAppTemplates() {
        return this.webConfigStore.imagicaAppTemplates();
    }
    async imagicaFontList() {
        return this.webConfigStore.imagicaAppfonts();
    }
    async stripeManagementLink() {
        return this.webConfigStore.stripeManagementLink();
    }
    async subscribeSuccessContent() {
        return this.webConfigStore.subscribeSuccessContent();
    }
}
